var _defs, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLionSpeakLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2567",
    "data-name": "Group 2567",
    xmlns: "http://www.w3.org/2000/svg",
    width: 213.731,
    height: 167.48,
    viewBox: "0 0 213.731 167.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2158",
    "data-name": "Rectangle 2158",
    width: 213.732,
    height: 167.48,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2568",
    "data-name": "Group 2568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2567-2",
    "data-name": "Group 2567",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M129.828,93.29s-1.243,14.545-16.494,14.189-20.219,4.611-23.057,11c0,0-2.483-8.336-1.064-13.3,0,0-23.057,13.3-41.324-15.076l5.5.888S39.019,75.2,18.8,78.57A45.965,45.965,0,0,1,44.7,66.686s-6.563-3.546-9.577-6.562-12.948-9.4-24.3-9.4a40.927,40.927,0,0,1,24.3-6.207S19.51,25.54,0,26.426c0,0,12.414-12.06,32.457-4.611s21.992,1.241,33.7.177A23.425,23.425,0,0,1,50.016,0s7.271,8.337,26.248,3.192,38.665-.177,44.518,13.834,7.093,14.188,7.093,14.188A17.954,17.954,0,0,1,142.6,21.46c10.642-.709,15.962,7.981,29.8,1.064,0,0-.621,11.395-8.6,14.853,0,0,3.858,2,11.041-3.325,0,0,.266,10.109-11.307,15.164a4.566,4.566,0,0,1,1.463,3.192c-.133,1.729-1.862,5.587,6.784,9.444S186.272,72.628,188,76.086s-1.064,7.05-2.793,10.642a30.161,30.161,0,0,1-6.119,7.981c-1.6,1.6-1.064,3.858-2.926,7.582s-5.72,9.178-10.509,10.509-8.38-5.055-14.366-3.725-14.9-4.124-15.83-11.44a8.334,8.334,0,0,1-5.629-4.345",
    transform: "translate(0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M124.064,78.874s-2.15,2.285-3.592,8.779c-1.862,8.38-6.976,11.972-16.4,10.971s-16.137,3.14-17.709,6.853c0,0,2.553-17.652,19.277-16.135,13.633,1.237,8.046-8.341,18.422-10.469",
    transform: "translate(5.541 5.06)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M124.6,72.987s-3.855-.144-6.14,4.712-2.713,8.281-11.424,6.711S93.181,85.98,89.325,91.265s-15.706,16.994-36.555-1c0,0,15.138,7.852,26.417-2.857s14.707-14.564,24.99-12.993,9.139-8.426,20.42-1.428",
    transform: "translate(3.386 4.521)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M118.076,67.207a8.149,8.149,0,0,0-8.139,2.57c-3.715,4-11.282-4.425-23.134,3.714S70.239,91.483,53.246,81.629s-21.418-10.851-25.7-10.138c0,0,14.136-7.281,30.7-3.714S80.377,57.069,92.8,56.07s20.421,4,20.421,4a21.45,21.45,0,0,0-15.28-.142,74.586,74.586,0,0,0-12.566,6.284S93.8,60.5,101.654,63.353s6.855-3.571,16.422,3.854",
    transform: "translate(1.767 3.589)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M126.008,39.826s4.789-11.854,18.339-4.815c9.344,4.849,13.348,6.655,18.678,2.551,0,0-9.143,10.554-17.195,4.683s-9.761-5.43-19.822-2.419",
    transform: "translate(8.084 2.103)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M130.815,44.392s-7.282-3.214-12.423-16.921S102.328,1.552,79.624,6.479s-26.989,0-26.989,0,.389,12.744,25.919,13.281c27.2.57,26.059,5.569,32.913,12.422s11.854,12.994,19.348,12.21",
    transform: "translate(3.377 0.344)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M45.716,43.988c1.9-3.887,2.957-8.12,4.963-11.972a42.834,42.834,0,0,1,2.773-5.068c-6.333,1.154-10.9,1.376-15.039.752,1.909,5.492,4.856,10.98,7.3,16.287",
    transform: "translate(2.464 1.729)",
    fill: "#f77c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M58.5,28.795c2.574,4.634,5.221,9.644,8.8,13.633,3.128-6.206,3.284-13.961,6.968-19.961a42.952,42.952,0,0,0-6.54,1.2c-4.167,1.089-7.79,1.978-11,2.681A9.678,9.678,0,0,1,58.5,28.795",
    transform: "translate(3.639 1.441)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M77.514,22.288c3.436,3.195,5.7,8,8.611,11.778,4.71-1.941,8.788-2.687,13.894-1.184,0,0-7.23-10.247-22.5-10.594",
    transform: "translate(4.973 1.43)",
    fill: "#f77c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M69.211,42.25c6.333-2.737,11.083-5.361,15.21-7.269-2.8-3.913-5.172-8.829-8.7-11.6C72.144,29,71.809,36.189,69.211,42.25",
    transform: "translate(4.44 1.5)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M43.895,44.718c-2.56-5.518-5.57-11.126-7.49-16.854-1.913,2.493-3.506,5.192-5.275,7.787,3.935,3.964,8.046,7.178,12.765,9.067",
    transform: "translate(1.997 1.788)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M60.091,34.707c-.946-1.728-2-3.352-3.055-5.013-.476-.752-.74-3.278-1.4-1.64-.577,1.425-1.978,2.411-2.7,3.8a59.793,59.793,0,0,0-2.951,6.893,56.011,56.011,0,0,1-3.12,7.219c5.438,1.211,11.7.723,19.324-2.16a46.845,46.845,0,0,1-6.094-9.1",
    transform: "translate(3.006 1.765)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M23.469,22.774c-6.78-1.37-10.955.258-10.955.258s6.154,1.3,13.664,7.262c-.839-2.532-1.686-5.058-2.708-7.519",
    transform: "translate(0.803 1.426)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M28.985,33.412c.258.249.517.515.777.776,1.646-2.442,3.171-4.956,4.941-7.309a48.663,48.663,0,0,1-5.246-2,35.383,35.383,0,0,0-3.943-1.465c1.256,3.295,2.287,6.668,3.471,9.993",
    transform: "translate(1.637 1.502)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M128.518,63.038s-22.7-34.057-47.552-19.92C56.16,57.233,46.483,50.4,39.628,47.4s-19.063-.857-19.063-.857,6.425-.428,16.921,7.711S59.948,68.5,78.4,58.755c14.994-7.926,29.131-8.354,50.122,4.283",
    transform: "translate(1.319 2.546)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M110.373,45.517a19.111,19.111,0,0,1,10-1.57s-10.139-8-13.995-8.282,4,9.852,4,9.852",
    transform: "translate(6.756 2.288)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M50.15,51.391l4.791,5.7L58.2,51.454a28.464,28.464,0,0,1-8.052-.064m-16.324-.8L38.958,47.4A23.133,23.133,0,0,0,31.01,45.85Zm9.2,2.527,3.408-2.586a64.081,64.081,0,0,1-7.48-3.131Zm23.822,3.429,3.937-8.7a51.292,51.292,0,0,1-10.71,3.311Zm47.851-7.73,1.6,6.105,4.775-.153a68.288,68.288,0,0,0-6.372-5.952M84.546,41.153l9.2,8.174,6.127-8.648a24.69,24.69,0,0,0-15.323.475m20.747,9.077,7.969-2.551A40.227,40.227,0,0,0,99.89,40.685ZM71.8,47.42l8.042,5.7,3.886-11.661A27.981,27.981,0,0,0,80.3,43.118a91.591,91.591,0,0,1-8.493,4.3",
    transform: "translate(1.989 2.546)",
    fill: "#f77c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M52.337,51.65l2.192,3.091,1.413-3.095a28.7,28.7,0,0,1-3.605,0m25.88-2.187,1.278-6c-1.808,1.014-3.535,1.913-5.187,2.713Zm9.235-9.209,5.923,4.608,4.212-4.68a24.5,24.5,0,0,0-10.135.072m-45.51,8.666,1.218,2.167L44.173,49.8c-.865-.339-1.676-.693-2.444-1.044Zm24.092,4.6,1.179-4.353c-1.45.515-2.83.94-4.143,1.283Zm39.929-6.362,4.778-1.168a42.2,42.2,0,0,0-6.608-3.715Zm-71.2,1.354,1.854-1.854a23.312,23.312,0,0,0-2.734-.538Zm81.717,1.976.444,1.948,1.424-.228c-.6-.574-1.223-1.149-1.868-1.721",
    transform: "translate(2.174 2.546)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M42.983,55.174l4.2-3.248,6.5,8.8-2.843-.271-4.06-6.768-3.655,2.842Z",
    transform: "translate(2.758 3.331)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M54.176,59.416l3.791-6.091,7.714,5.685-1.354,1.083-5.955-4.331L55.26,60.77Z",
    transform: "translate(3.476 3.421)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M66.259,57.447l3.655-7.175,7.309,5.279L76,56.229l-5.686-3.52-3.111,5.957Z",
    transform: "translate(4.251 3.225)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M79.106,53.839l2.572-8.527,8.392,5.55-2.436.812-5.009-3.791-1.759,5.551Z",
    transform: "translate(5.075 2.907)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M92.461,49.43l3.519-5.008L99.5,51.731l-1.354-.27L95.71,47.4l-2.03,3.249Z",
    transform: "translate(5.932 2.85)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M101.747,51.159l7.444-2.03,1.083,5.279-1.355-.543-.541-2.976L105,51.971Z",
    transform: "translate(6.528 3.152)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M113.321,55.377l2.979-.27,2.706,3.519Z",
    transform: "translate(7.27 3.535)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M42,54.669l-3.384-5.414L35.1,50.61l1.217,1.217L37.8,51.15l3.248,4.2Z",
    transform: "translate(2.252 3.16)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M122.824,36.4c-.256-.391-.512-.8-.767-1.224a3.611,3.611,0,0,0-3.812,3.742c.5.457,1,.9,1.494,1.313a2.573,2.573,0,0,1,3.085-3.831M109.677,22.262a3.639,3.639,0,1,0-5,1.235,3.641,3.641,0,0,0,5-1.235m-4.451.33a2.583,2.583,0,1,1,3.547-.877,2.584,2.584,0,0,1-3.547.877m19.232,16.1A2.58,2.58,0,0,1,121,41.226c.547.409,1.1.778,1.657,1.121a3.623,3.623,0,0,0,2.339-1.669,3.573,3.573,0,0,0,.368-.878q-.444-.517-.9-1.106M127,41.542c-.047.089-.074.183-.127.27a5.771,5.771,0,0,1-1.713,1.793,13.028,13.028,0,0,0,1.4.46,7.021,7.021,0,0,0,1.351-1.627c.009-.014.015-.029.022-.042-.3-.256-.607-.538-.933-.855M78.522,7.99a3.641,3.641,0,0,0,5-1.237,3.564,3.564,0,0,0,.4-1.021c-.382.049-.775.112-1.164.172a2.7,2.7,0,0,1-.145.3,2.583,2.583,0,0,1-3.545.877,2.516,2.516,0,0,1-.486-.388c-.392.082-.787.166-1.168.242A3.623,3.623,0,0,0,78.522,7.99m37.333,24.034a3.64,3.64,0,1,0-6.721-2.39c.37.433.756.878,1.167,1.331a2.576,2.576,0,1,1,1.53,1.592c.4.4.8.808,1.194,1.2a3.63,3.63,0,0,0,2.83-1.738M89.65,11.139a3.639,3.639,0,1,0,1.235,5,3.639,3.639,0,0,0-1.235-5m.33,4.449a2.583,2.583,0,1,1-.877-3.546,2.581,2.581,0,0,1,.877,3.546m30.892,17.48q-.287-.548-.57-1.128a7.256,7.256,0,0,0-.827.238,6.892,6.892,0,0,0,.258-1.452c-.459-1.015-.911-2.094-1.346-3.256q-.512-1.363-1.1-2.7a7.352,7.352,0,0,0-.906-.658,6.994,6.994,0,0,0-3.337-.989,7.036,7.036,0,0,0-.948-7.081q-.425-.532-.872-1.045c-.028.012-.053.03-.081.043a6.929,6.929,0,0,0-6.9-1.294,7.068,7.068,0,0,0-1.293-4.754c.021-.168.054-.336.089-.5A27.125,27.125,0,0,0,96.49,6.132c-.078.007-.156,0-.234.015,0-.023,0-.048,0-.071-.353-.076-.714-.14-1.075-.2a2.57,2.57,0,0,1-.017.527,7.009,7.009,0,0,0-3.188,2.041,2.477,2.477,0,0,1-.667-.277,2.574,2.574,0,0,1-1.174-2.777c-.349-.007-.7-.014-1.058-.012a3.668,3.668,0,0,0,.232,2.01,7.025,7.025,0,0,0-2.345-.121,5.846,5.846,0,0,1-.106-1.808c-.407.026-.81.048-1.225.086a7.185,7.185,0,0,0,.094,1.649c-.06.139-.122.278-.195.413a6.976,6.976,0,0,0-3.192,2.2,5.359,5.359,0,0,0-.458-.339,7.012,7.012,0,0,0-5.955-.6,7.1,7.1,0,0,0-.064-1.626c-.405.074-.8.144-1.191.213a5.693,5.693,0,0,1-1.644,4.906,6.979,6.979,0,0,0-1.428-1.7,3.369,3.369,0,0,0,.434-.552,3.6,3.6,0,0,0,.482-2.3c-.351.054-.7.105-1.039.154a2.56,2.56,0,0,1-.349,1.6,2.526,2.526,0,0,1-.372.47c-.044-.029-.085-.062-.131-.088a6.964,6.964,0,0,0-4.143-.972c-.009-.155-.042-.308-.062-.459-.417.03-.823.056-1.216.077a5.771,5.771,0,0,1-6.329,6.568,21.11,21.11,0,0,0,2.316,1.267c-.006-.074-.019-.148-.023-.223a7.066,7.066,0,0,0,2.287-1.039,3.668,3.668,0,0,0,.209,2.271c.542.19,1.115.371,1.711.544a2.588,2.588,0,1,1,2.061.528q.843.195,1.748.36a3.6,3.6,0,0,0,.917-1.011,3.626,3.626,0,0,0-4.388-5.274,7.011,7.011,0,0,0,.729-2.386,5.8,5.8,0,0,1,5.537,8.793c-.062.1-.145.185-.214.285.737.094,1.494.181,2.289.25a6.106,6.106,0,0,1-.619-.733,7.039,7.039,0,0,0-.279-6.2,5.639,5.639,0,0,1,.494.857,7.044,7.044,0,0,0,1.3-1.577,7.2,7.2,0,0,0,.695-1.568,5.8,5.8,0,0,1,5.61.205c.14.085.266.181.394.277a7.012,7.012,0,0,0-.8,2.19,3.427,3.427,0,0,0-.728-.587,3.639,3.639,0,1,0,1.237,5c.02-.033.033-.069.05-.1a6.98,6.98,0,0,0,1.341,1.91,5.645,5.645,0,0,1-.669.683c3.435.135,6.368.351,8.869.646a7.262,7.262,0,0,0,.825-.468,3.615,3.615,0,0,0-.083.562c.353.046.71.09,1.046.139a2.545,2.545,0,0,1,.356-1.224,2.583,2.583,0,0,1,4.64,2.215q.527.139,1.016.289a3.622,3.622,0,0,0-4.716-4.563,7.025,7.025,0,0,0,.73-2.387,5.762,5.762,0,0,1,3.555.786,5.831,5.831,0,0,1,2.5,6.893c.385.156.753.318,1.1.487a7.037,7.037,0,0,0-.438-5.774,5.521,5.521,0,0,1,.495.857,6.9,6.9,0,0,0,1.993-3.146,5.818,5.818,0,1,1,2.092,10.991c.49.479.95.978,1.406,1.5-.043-.1-.079-.2-.125-.293a7.018,7.018,0,0,0,5.039-3.033,5.765,5.765,0,0,1,3.377.807,5.827,5.827,0,0,1,2.019,7.927,7.022,7.022,0,0,0-1.8,1.9,6.047,6.047,0,0,1-1.165.588c.512.518,1.021,1.03,1.521,1.523a5.883,5.883,0,0,1,.523-1.225,7.01,7.01,0,0,0,1.806-1.906,5.875,5.875,0,0,1,2.222-.893M80.453,16.833a2.611,2.611,0,1,1,.33-1.727c.011.094.022.187.038.281a2.572,2.572,0,0,1-.368,1.446m12.311.434a5.833,5.833,0,1,1-1.981-8.008,5.835,5.835,0,0,1,1.981,8.008m6.684-2.823a2.573,2.573,0,0,1-.372.469c-.046-.028-.086-.061-.132-.088a6.981,6.981,0,0,0-4.143-.971,6.833,6.833,0,0,0-.133-.989,2.54,2.54,0,0,1,.358-1.091,2.583,2.583,0,1,1,4.423,2.669m2.782,1.678a5.776,5.776,0,0,1-.883,1.115,6.96,6.96,0,0,0-1.429-1.7,3.259,3.259,0,0,0,.434-.552,3.636,3.636,0,0,0-6.183-3.827,5.386,5.386,0,0,1,.181.591,6.994,6.994,0,0,0-2.035-2.872l.05-.056c.171.139.359.271.508.419a5.83,5.83,0,0,1,9.357,6.878m-39.663-4.87a3.623,3.623,0,0,0,.443-2.59c-.375,0-.736,0-1.083,0a2.576,2.576,0,1,1-4.787-.417q-.571-.1-1.058-.222a3.634,3.634,0,0,0,6.485,3.23m44.275,1.62a3.625,3.625,0,0,0,2.773.41c-.332-.327-.675-.647-1.023-.959a2.526,2.526,0,0,1-2.352-1.877q-.559-.4-1.143-.768a3.629,3.629,0,0,0,1.744,3.195M52.926,6.733c-.068.171-.133.344-.187.516a9.789,9.789,0,0,0,.892,2.46,5.762,5.762,0,0,1,.364-2.375,5.8,5.8,0,0,1-1.068-.6",
    transform: "translate(3.384 0.345)",
    fill: "#1e7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M85.663,69.118c6.678-4.512,8.663-5.054,16.243-3.97,5.212.744,8.034-.73,9.29-1.724-3.038-.434-4.372,1.7-9.542-.173a12.75,12.75,0,0,0-1.627-.462c-4.29-.07-10.333.645-15.266,4.344-8.662,6.5-16.6,10.829-29.055,6.678-8.729-2.909-15.768-4.572-21.314-5a42.677,42.677,0,0,0-6.849,2.58,11.931,11.931,0,0,1,3.91-.039,60.256,60.256,0,0,1,22.266,4.627c15.522,6.315,25.266-2.346,31.944-6.858m30.431-3.455a24.047,24.047,0,0,1-13.648,2.01C93.6,66.589,91.077,67.313,83.5,73.81S69.06,84.456,56.607,80.126a71.933,71.933,0,0,0-11.166-2.98c2.266,1.217,4.841,2.661,7.8,4.379.069.042.133.074.2.113,2.34.46,5.044,1.044,7.672,1.736,6.266,1.649,10.585.126,18.3-4.279,2.236-1.815,4.612-3.808,7.38-5.707,11.852-8.139,19.419.285,23.134-3.713a8.147,8.147,0,0,1,8.139-2.57c-.721-.559-1.374-1.031-1.983-1.443m-33.137-.876c8.023-6.255,12.19-6.259,15.827-5.261a19.153,19.153,0,0,1,3.444-.848c-2.465-.968-10.635-3.279-19.814,3.944C71.406,71.282,65.45,72.185,55.164,68.4c-1.757-.649-3.388-1.2-4.9-1.679a48.531,48.531,0,0,0-7.214.324c3.065.725,7.163,1.809,11.754,3.34,9.746,3.249,15.881,3.971,28.154-5.594",
    transform: "translate(1.767 3.692)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M111.6,72.829l4.924,4.573,3.787-6.314c-4.261-1.575-6.169.2-8.711,1.741m-30.46,12.2c2.738.766,8.449,2.927,8.449,2.927l-.754-9.812c-2.224,1.715-4.667,4.005-7.695,6.884M61.366,92.87l5.073,4.293,2.093-4.519a23.705,23.705,0,0,1-7.166.227m17.27-5.462a19.943,19.943,0,0,1-8.465,4.844l9.667,5.317s0-7.857-.071-11.236c-.374.358-.736.7-1.13,1.076M96.893,82.68,99.306,74.1a16.125,16.125,0,0,0-9.965,3.673Zm6.732-8.265A25.74,25.74,0,0,0,99.4,74.1l8.858,9.261,2.273-9.933a10.656,10.656,0,0,1-6.911.991",
    transform: "translate(3.937 4.521)",
    fill: "#5bae7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M117.45,70.488a6.821,6.821,0,0,0-3.98,1.057l2.846,2.608,1.218-3.519ZM73.082,91.1,77.6,94.185l-.626-5.526a19.923,19.923,0,0,1-3.9,2.437m9.624-7.744,4.644,1.222-1.475-4.129c-.988.873-2.04,1.843-3.169,2.907M65.558,94.861l.818-1.937c-.621.062-1.232.095-1.836.106ZM104.2,74.511l3.315,5.327.451-5.53a11.244,11.244,0,0,1-3.766.2m-8.461,4.108L96.8,74.272A14.968,14.968,0,0,0,91.689,76.1Z",
    transform: "translate(4.141 4.521)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M68.422,96.737l1.083-4.149,7.579,4.421-2.436.089-4.332-2.526L69.6,97.189Z",
    transform: "translate(4.39 5.94)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M81.026,93.981l-.9-7.67,7.13,2.256-.542,1.354-4.963-1.083.721,4.332Z",
    transform: "translate(5.14 5.537)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M89.691,85.488l-1.174-6.044,5.144,3.7-.9.631L90.052,82.33l.813,2.616Z",
    transform: "translate(5.679 5.097)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M96.4,82.414l1.442-5.685L103.8,82.5l-1.714-.27L98.57,78.9l-.724,3.339Z",
    transform: "translate(6.185 4.923)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M106.749,83.028l2.257-8.844,4.782,4.243-.721,1.354L109.638,76.8,108.1,83.119Z",
    transform: "translate(6.849 4.759)",
    fill: "#a2cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M138.426,26.44a3.6,3.6,0,0,0,.4-2.121c-.138-.38-.428-.662-1.523-.54a5.632,5.632,0,0,0-1.022.233,5.972,5.972,0,0,0-3.1,2.431,15.469,15.469,0,0,1,5.24,0",
    transform: "translate(8.545 1.524)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M138.91,25.766a7.54,7.54,0,0,1,2.313-1.273c.175-.06.368-.094.552-.137a20.594,20.594,0,0,0-3.014-.608,1.246,1.246,0,0,1,.225.4,2.961,2.961,0,0,1-.077,1.616",
    transform: "translate(8.902 1.524)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M138.8,26.508c1.707.311,3.417.767,5.129,1.2.019-.014.134-.1.341-.235a1.867,1.867,0,0,0,.352-.586,2.022,2.022,0,0,0,.1-1.334,1.391,1.391,0,0,0-.118-.244c-.117-.049-.227-.086-.345-.138-.415-.179-.84-.338-1.27-.491a5.478,5.478,0,0,0-1.6.265,7.178,7.178,0,0,0-2.586,1.563",
    transform: "translate(8.905 1.583)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M127.475,27.125a1.081,1.081,0,0,1,.419.594c.019.064.037.131.051.2a10.7,10.7,0,0,1,1.591-2.788,12.468,12.468,0,0,0-2.9,1.943l.01,0a.959.959,0,0,1,.829.057",
    transform: "translate(8.124 1.612)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M133.507,25.224a6.443,6.443,0,0,1,2.387-1.608,18.511,18.511,0,0,0-3.327.427,1.518,1.518,0,0,1,.877.914,1.434,1.434,0,0,1,.063.267",
    transform: "translate(8.505 1.515)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M128.145,28.7a13.374,13.374,0,0,1,3.692-1.882c.238-.079.495-.145.748-.214.079-.089.172-.193.305-.335a1.211,1.211,0,0,0,.325-1.19c-.178-.522-.8-.955-2.042-.564-.955.3-1.826,1.547-2.408,2.738a15.528,15.528,0,0,0-.619,1.447",
    transform: "translate(8.221 1.563)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M139.125,27.13l-.031-.088.147-.1a14.844,14.844,0,0,0-6.438-.06c-.023.019-.051.044-.085.07.849.647,2.786,1.991,4.351,2.1.117,0,.233-.011.351-.012a2.08,2.08,0,0,0,.358-.029,3.213,3.213,0,0,0,.37-.1,1.306,1.306,0,0,0,.977-1.792",
    transform: "translate(8.515 1.704)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M148.9,26.78a1.19,1.19,0,0,1,.249.411,2.017,2.017,0,0,1-.233,1.476,13.175,13.175,0,0,0,5.282-.561,12.992,12.992,0,0,0,3.681-1.947c.018-.084.028-.133.028-.133s-3.04,1.973-9.007.754",
    transform: "translate(9.553 1.67)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M132.031,27.157a12.636,12.636,0,0,0-4.273,2.378,10.537,10.537,0,0,0,1.235.5,5.775,5.775,0,0,0,2.709.3c.349-.15.7-.295,1.068-.422.477-.386.444-.889.275-1.478a5.13,5.13,0,0,0-.735-1.35c-.09.029-.189.05-.28.08",
    transform: "translate(8.196 1.737)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M144.282,27.759a33.423,33.423,0,0,0,4.325.819c.2-.343.468-.894.32-1.257-.077-.218-.252-.432-.785-.58a3.68,3.68,0,0,0-2.079.151,8.019,8.019,0,0,0-1.78.866",
    transform: "translate(9.257 1.71)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M146.871,26.222c-.633-.195-1.294-.432-1.975-.7a2.723,2.723,0,0,1-.092,1.367,7.7,7.7,0,0,1,1.056-.441,5.517,5.517,0,0,1,1.011-.228",
    transform: "translate(9.29 1.637)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M127.536,29.147a3.869,3.869,0,0,0-.055-1.4c-.147-.317-.167-.4-.565-.308a2.182,2.182,0,0,0-.541.3c-1.263.843-1.374,2.909-1.308,4.194a13.541,13.541,0,0,1,2.469-2.779",
    transform: "translate(8.023 1.758)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M150.708,30.408c-.1-.352-.621-.7-1.151-.9a6.154,6.154,0,0,0-1.007-.3l-.444-.081.126-.16a31.089,31.089,0,0,1-3.471-.629c1.851,2.476,4.139,3.636,5.215,3.241a1.11,1.11,0,0,0,.625-.513.791.791,0,0,0,.107-.657",
    transform: "translate(9.287 1.818)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M139.358,27.652a1.715,1.715,0,0,1-.753,1.388,16.565,16.565,0,0,1,2.777.477l-.249-.208c-.695-.607-1.334-1.223-1.775-1.657",
    transform: "translate(8.892 1.774)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M144.383,28.365l.133-.084c-1.721-.419-3.422-.894-5.1-1.248.407.409,1.171,1.163,2.022,1.907A15,15,0,0,0,142.752,30c.322.116.646.233.975.368.36.148.708.282,1.049.409a.517.517,0,0,0,.208-.4,2.68,2.68,0,0,0-.166-.994,6.69,6.69,0,0,0-.435-1.015",
    transform: "translate(8.944 1.734)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M149.671,29.19a2.251,2.251,0,0,1,1.237,1.139,1.338,1.338,0,0,1-.152,1.094,1.642,1.642,0,0,1-.586.576,7.518,7.518,0,0,0,7.405-5.07,13.313,13.313,0,0,1-3.261,1.636,13.8,13.8,0,0,1-4.643.626",
    transform: "translate(9.602 1.728)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M124.711,32.584a8.819,8.819,0,0,1,.171-3.413,12.592,12.592,0,0,0-1.735,7.162,15.593,15.593,0,0,1,1.563-3.749",
    transform: "translate(7.9 1.872)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M144.969,30.806a20.879,20.879,0,0,0,2.565.714,9.513,9.513,0,0,1-2.419-1.96,1.663,1.663,0,0,1-.146,1.246",
    transform: "translate(9.301 1.896)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M127.418,29.822a13.445,13.445,0,0,0-2.259,2.833c.019.128.031.2.031.208h0l-.172.033c-.062.11-.125.216-.183.321a1.039,1.039,0,0,0,.172.04,2.366,2.366,0,0,0,1.085-.112,4.007,4.007,0,0,0,1.273-.731,1.459,1.459,0,0,0,.552-1.713,2.794,2.794,0,0,0-.5-.879",
    transform: "translate(8.009 1.913)",
    fill: "#e82727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M124.663,33.492a14.709,14.709,0,0,0-1.106,3.05,23.467,23.467,0,0,1,3.116-3.25c-.11.046-.225.11-.33.145a2.711,2.711,0,0,1-1.68.055",
    transform: "translate(7.927 2.136)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M133.074,27.832c.053.121.1.248.147.377a2.07,2.07,0,0,1,.039,1.384,15.767,15.767,0,0,1,2.166-.47,11.54,11.54,0,0,1-2.352-1.291",
    transform: "translate(8.538 1.786)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M128.225,30.516a1.965,1.965,0,0,1-.16,1.66,20.012,20.012,0,0,1,2.383-1.459,8.571,8.571,0,0,1-2.41-.641,3.1,3.1,0,0,1,.187.439",
    transform: "translate(8.214 1.93)",
    fill: "#ffac00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M129.4,42.13s8.912-.931,15.563,3.059,8.38,3.592,8.114,6.119-1.463,5.986,5.986,9.577,14.632,9.577,13.7,10.243-6.252,1.2-9.976,1.2-9.843-8.247-12.77-11.44,0-8.912-1.33-9.71-8.38,4.39-14.9,1.862-7.848-8.513-4.39-10.908",
    transform: "translate(8.183 2.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M124.554,45.749s.8,8.646,10.642,10.509,14.5,9.311,7.316,13.568-20.485-8.114-26.471-21.682c4.115-1.763,4.134-1.664,8.513-2.394",
    transform: "translate(7.445 2.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M150.025,62.4s-.4,8.114-7.316,9.976-14.632-2.793-18.357-5.587-10.376-6.119-13.435-6.917c0,0,6.385,5.986,12.238,11.839a18.544,18.544,0,0,0,18.091,5.321s-2.66,6.784,3.459,9.976,10.908-2,20.884-.133c0,0,4.922-8.779-2.394-12.77s-6.917-3.192-13.169-11.706",
    transform: "translate(7.116 3.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M135.91,81.183s-1.406,5.587,5.9,8.38-13.354,4.656-17.431-4.523,7.872-7.848,11.527-3.858",
    transform: "translate(7.926 5.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M131.542,92.737s5.986,4.257,15.43-1.2,17.185-1.19,17.648-.71c2.128,2.218-3.458,10.819-8.426,11.972-2.261.525-5.5-3.547-11.882-3.015s-12.5-2.926-12.77-7.05",
    transform: "translate(8.439 5.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M165.127,86.4a34.04,34.04,0,0,0,2.216-5.321,6.467,6.467,0,0,1,3.547-4.612c1.953-.8,2.04,2.306-.532,6.031s-5.5,5.5-5.23,3.9",
    transform: "translate(10.593 4.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M137.4,73.852a19.028,19.028,0,0,1-3.2-.637,10.517,10.517,0,0,0,3.769,5.438,20.437,20.437,0,0,0,2.882-.461,14.516,14.516,0,0,1-3.448-4.34m3.6,23.26a14.5,14.5,0,0,1-3.88.113c3.072,3.252,6.836,2.918,14.7,3.167a20.1,20.1,0,0,1,9.864,2.645,18.119,18.119,0,0,0,1.761-1.984c-4.435-3.114-10.347-1.9-16.148-2.391a16.215,16.215,0,0,1-6.3-1.55m-11.6-47.952c5.476.986,10.44,2.13,13.86,3.793,1.49-.439,2.814-.965,3.867-1.35-4.936-2.788-16.284-4.632-18.765-5.011a6.629,6.629,0,0,0,1.039,2.569m22.94,39.632c.652-1.977.3-5.215-5.709-7.289a17.291,17.291,0,0,1-5.74-3.271,10.131,10.131,0,0,0-.476,2.089A48.8,48.8,0,0,0,146.1,83.1c4.887,2.071,5.184,4.451,4.71,5.953q.753-.109,1.531-.26M135.918,78.721c-6.232-2.393-12.043-9.455-14.265-12.4-1.023-.642-2.13-1.28-3.249-1.884a38.18,38.18,0,0,0,13.288,13.694,17.9,17.9,0,0,0,4.226.588m-2.185-18.234c7.807,3.644,9.417,7.438,9.751,8.922a6.517,6.517,0,0,0,2.118-2.519c-.98-2.611-4.293-6.092-12.268-8.4-9.772-2.825-10.789-10.439-10.9-12.154-.752.128-1.337.237-1.88.368.659,4.23,4.114,9.552,13.175,13.781m25.939,2.394c-7.449-3.592-6.917-6.651-7.05-9.71s-1.6-3.459-7.715-6.917a47.047,47.047,0,0,0-11.6-4.208,27.141,27.141,0,0,0-3.161.084,4.216,4.216,0,0,0-1.339,1.511c4.637.417,14.9,3.705,20.227,7,5.587,3.459,1.064,8.779,9.311,13.169a44.8,44.8,0,0,1,11.1,8.178,25.306,25.306,0,0,0,3.072-.494,60.264,60.264,0,0,0-12.839-8.615M133.586,81.57a12.879,12.879,0,0,0-2.541-.844c-.828,7.469,2.818,11.409,5.464,13.246a24.006,24.006,0,0,0,2.91.19c-7.458-3.962-6-11.824-5.834-12.592m-6.279-1.019a4.474,4.474,0,0,0-2.185.936,17.245,17.245,0,0,0,4.416,10.453,17.913,17.913,0,0,0,3.091,1.226,17.178,17.178,0,0,1-5.323-12.616m3.234-16.872c4.713,2.357,6.389,5.244,6.984,7.048a8.064,8.064,0,0,0,2.777.113c-.38-1.825-2.13-5.422-9.628-8.89a25.47,25.47,0,0,1-13.389-14.095c-.372.155-.779.328-1.243.527a52.7,52.7,0,0,0,6.318,10.6,63.733,63.733,0,0,0,8.181,4.7m16.623,31.283c-.485.259-.963.5-1.428.7a39.9,39.9,0,0,1,19.589,2.322,8.152,8.152,0,0,0,.709-2.237c-7.243-3.36-15.239-1.809-18.87-.79m2.445-40.783c-.27,2.107-.563,4.838,1.15,6.706.159.173.331.368.508.569-1.7-2.65-.62-4.778-1.658-7.276m13.92,18.146c.607,0,1.257-.016,1.924-.042a69.591,69.591,0,0,0-9.373-6.609,20.815,20.815,0,0,1-3.232-2.378c3.185,3.746,7.7,9.029,10.681,9.029m-16.262-2.12c.734,1.914,2.877,4.86,9.079,7.308,7.048,2.782,5.755,7.5,4.327,10.105a23.5,23.5,0,0,1,3.072.178c1.71-3.795.079-9.267-6.335-11.879a16.485,16.485,0,0,1-8.7-8.275,11.431,11.431,0,0,1-1.439,2.564m-2.377,2.209a8.982,8.982,0,0,1-2.39,1.066c.478,2.211,1.823,4.562,9.723,7.358,5.3,1.876,4.9,5.049,3.8,7.226.647-.113,1.323-.21,2.022-.288,1.427-2.844.16-6.7-5.82-8.8-5.591-1.968-6.987-5.214-7.333-6.562",
    transform: "translate(7.445 2.697)",
    fill: "#c7c9cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M5.245,113.59v25.5H20.178v2H3.2V113.59Z",
    transform: "translate(0.205 7.288)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M28.52,115.344a1.5,1.5,0,1,1-2.993,0,1.5,1.5,0,1,1,2.993,0m-2.462,25.739h1.857v-19.49H26.058Z",
    transform: "translate(1.638 7.302)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M35.89,130.964c0-6.169,4.245-10.1,9.514-10.1s9.511,3.93,9.511,10.1-4.244,9.942-9.511,9.942-9.514-3.772-9.514-9.942m17.206,0c0-5.03-3.449-8.291-7.693-8.291s-7.694,3.261-7.694,8.291,3.448,8.056,7.694,8.056,7.693-3.025,7.693-8.056",
    transform: "translate(2.303 7.754)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M63.172,121.218v3.457a7.393,7.393,0,0,1,6.671-3.812c5,0,8.45,3.183,8.45,8.566v11.2H76.436V129.47c0-4.4-2.615-6.76-6.67-6.72-3.866.04-6.556,3.066-6.556,7.075V140.63H61.353V121.218Z",
    transform: "translate(3.936 7.754)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M103.02,118.918c-1.933-3.222-5.041-3.694-8.035-3.733-3.107,0-8.034,1.179-8.034,5.579,0,3.5,3.638,4.324,8.111,5.187,5.116,1.022,10.421,1.965,10.421,7.9-.037,6.208-6.064,7.7-10.5,7.7-4.131,0-8.83-1.77-10.876-5.974l1.819-.942c1.63,3.339,5.8,4.99,9.057,4.99s8.453-.943,8.453-5.816c.037-4.126-4.359-5.029-8.718-5.894-4.85-.982-9.815-2-9.815-7.072-.115-5.816,5.722-7.624,10.08-7.624,3.791,0,7.087.628,9.7,4.676Z",
    transform: "translate(5.396 7.264)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M111.851,148.721V121.215h1.819v4.6a8.881,8.881,0,0,1,8.111-4.873c5.078.2,9.1,3.733,9.1,9.981,0,6.523-4.244,10.059-9.512,10.059a8.412,8.412,0,0,1-7.731-4.833v12.575Zm17.168-17.8c0-5.462-3.411-8.134-7.656-8.134-4.358,0-7.579,3.419-7.579,8.174s3.3,8.174,7.579,8.174c4.245,0,7.656-2.751,7.656-8.213",
    transform: "translate(7.176 7.759)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M136.565,130.921c0-5.816,4.245-10.02,9.514-10.02s9.967,3.34,9.246,10.925H138.46a7.471,7.471,0,0,0,7.618,7.192c2.462,0,5.342-1.022,6.746-2.948l1.326,1.1a10.133,10.133,0,0,1-8.072,3.733c-5.269,0-9.514-3.812-9.514-9.982m17.094-.785c-.038-4.794-3.071-7.466-7.58-7.466-3.867,0-7.2,2.711-7.618,7.466Z",
    transform: "translate(8.761 7.757)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M180.341,121.212v19.411h-1.857V136.5a8.688,8.688,0,0,1-7.656,4.441c-5.23,0-9.513-4.087-9.513-10.021s4.282-9.941,9.513-9.941a8.436,8.436,0,0,1,7.656,4.479v-4.243Zm-17.168,9.705c0,4.873,3.411,8.134,7.656,8.134,10.422,0,10.422-16.228,0-16.228-4.245,0-7.656,3.222-7.656,8.094",
    transform: "translate(10.349 7.761)",
    fill: "#cf5819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M189.309,113.59v16.583l8.831-8.488H200.6v.079l-9.474,9.077L201.7,140.979v.118h-2.35l-10.043-9.51v9.51h-1.819V113.59Z",
    transform: "translate(12.029 7.288)",
    fill: "#cf5819"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M2.632,149.836v.464H5.025v6.981h.464V150.3h2.16v-.464Z",
    transform: "translate(0.169 9.613)",
    fill: "#030404"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2570",
    "data-name": "Group 2570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M14.344,157.281,11.7,154.059h-.9v3.222h-.464v-7.445h1.588a4.142,4.142,0,0,1,1.172.152,2.56,2.56,0,0,1,.853.421,1.746,1.746,0,0,1,.513.695,2.236,2.236,0,0,1,.159.916,1.671,1.671,0,0,1-.214.909,2.27,2.27,0,0,1-.554.642,2.643,2.643,0,0,1-.544.28,3.5,3.5,0,0,1-1.018.2l2.685,3.234Zm-2.051-3.686a2.486,2.486,0,0,0,.665-.092,1.722,1.722,0,0,0,.6-.3,1.594,1.594,0,0,0,.428-.495,1.5,1.5,0,0,0,.17-.69,2.233,2.233,0,0,0-.128-.726,1.262,1.262,0,0,0-.372-.531,1.9,1.9,0,0,0-.7-.342,3.831,3.831,0,0,0-1.048-.123H10.792v3.3Z",
    transform: "translate(0.663 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M23.4,157.306l-.94-2.209H18.754l-.952,2.209h-.5l3.295-7.86,3.307,7.86Zm-1.135-2.673L20.6,150.471l-1.66,4.162Z",
    transform: "translate(1.11 9.588)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2159",
    "data-name": "Rectangle 2159",
    width: 0.464,
    height: 7.445,
    transform: "translate(28.528 159.449)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M31.1,149.423l5.517,7.128v-6.688h.451v8.031l-5.5-7.128v6.541H31.1Z",
    transform: "translate(1.995 9.586)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2160",
    "data-name": "Rectangle 2160",
    width: 0.464,
    height: 7.445,
    transform: "translate(43.148 159.449)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M44.837,149.423l5.517,7.128v-6.688H50.8v8.031l-5.5-7.128v6.541h-.464Z",
    transform: "translate(2.877 9.586)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M57.628,157.436a3.905,3.905,0,0,1-1.544-.3,3.755,3.755,0,0,1-1.226-.835,3.945,3.945,0,0,1-.8-1.233,3.861,3.861,0,0,1-.287-1.489,3.94,3.94,0,0,1,1.087-2.747,3.842,3.842,0,0,1,1.226-.824,3.906,3.906,0,0,1,1.544-.3,3.8,3.8,0,0,1,1.569.325,4.094,4.094,0,0,1,1.275.883l-.305.33a3.625,3.625,0,0,0-1.141-.794,3.475,3.475,0,0,0-1.4-.28,3.42,3.42,0,0,0-1.367.269,3.365,3.365,0,0,0-1.074.725,3.32,3.32,0,0,0-.708,1.081,3.448,3.448,0,0,0-.256,1.33,3.412,3.412,0,0,0,.256,1.317,3.315,3.315,0,0,0,.708,1.08,3.353,3.353,0,0,0,1.074.727,3.419,3.419,0,0,0,1.367.267h.147a3.225,3.225,0,0,0,.982-.152,3.1,3.1,0,0,0,.866-.426,2.4,2.4,0,0,0,.623-.642,1.446,1.446,0,0,0,.238-.806V153.9H58.054v-.465h2.893v1.624a1.786,1.786,0,0,1-.214.8,2.449,2.449,0,0,1-.629.768,3.48,3.48,0,0,1-1.036.58,4.067,4.067,0,0,1-1.429.232Z",
    transform: "translate(3.45 9.605)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M75.516,157.306l-.94-2.209h-3.71l-.952,2.209h-.5l3.3-7.86,3.307,7.86Zm-1.134-2.673-1.672-4.162-1.66,4.162Z",
    transform: "translate(4.453 9.588)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M83.055,150.3h-2.16v6.982h-.464V150.3H78.038v-.464h5.016Z",
    transform: "translate(5.007 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M96.951,157.306l-.94-2.209H92.3l-.952,2.209h-.5l3.3-7.86,3.307,7.86Zm-1.134-2.673-1.672-4.162-1.66,4.162Z",
    transform: "translate(5.829 9.588)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M111.84,157.281h-.464v-3.747h-4.662v3.747h-.464v-7.445h.464v3.234h4.662v-3.234h.464Z",
    transform: "translate(6.817 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2161",
    "data-name": "Rectangle 2161",
    width: 0.465,
    height: 7.445,
    transform: "translate(122.806 159.449)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M123.1,157.436a3.905,3.905,0,0,1-1.544-.3,3.782,3.782,0,0,1-1.227-.835,3.926,3.926,0,0,1-.8-1.233,3.881,3.881,0,0,1-.287-1.489,3.953,3.953,0,0,1,.287-1.507,3.773,3.773,0,0,1,3.57-2.362,3.8,3.8,0,0,1,1.568.325,4.112,4.112,0,0,1,1.276.883l-.3.33a3.646,3.646,0,0,0-1.143-.794,3.469,3.469,0,0,0-1.4-.28,3.416,3.416,0,0,0-1.367.269,3.365,3.365,0,0,0-1.074.725,3.3,3.3,0,0,0-.708,1.081,3.448,3.448,0,0,0-.256,1.33,3.411,3.411,0,0,0,.256,1.317,3.3,3.3,0,0,0,.708,1.08,3.353,3.353,0,0,0,1.074.727,3.415,3.415,0,0,0,1.367.267h.146a3.232,3.232,0,0,0,.983-.152,3.08,3.08,0,0,0,.865-.426,2.425,2.425,0,0,0,.624-.642,1.455,1.455,0,0,0,.238-.806V153.9h-2.429v-.465h2.892v1.624a1.773,1.773,0,0,1-.214.8,2.434,2.434,0,0,1-.629.768,3.467,3.467,0,0,1-1.036.58,4.056,4.056,0,0,1-1.428.232Z",
    transform: "translate(7.65 9.605)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M135.375,157.281h-.464v-3.747h-4.662v3.747h-.464v-7.445h.464v3.234h4.662v-3.234h.464Z",
    transform: "translate(8.326 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M143.458,157.281h-4.6v-7.445h4.3v.463h-3.833v2.771h3.162v.464h-3.162v3.283h4.139Z",
    transform: "translate(8.908 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M150.407,157.281l-2.649-3.222h-.9v3.222h-.464v-7.445h1.587a4.139,4.139,0,0,1,1.173.152,2.56,2.56,0,0,1,.853.421,1.733,1.733,0,0,1,.512.695,2.236,2.236,0,0,1,.161.916,1.69,1.69,0,0,1-.214.909,2.26,2.26,0,0,1-.557.642,2.659,2.659,0,0,1-.543.28,3.5,3.5,0,0,1-1.019.2l2.685,3.234Zm-2.051-3.686a2.478,2.478,0,0,0,.664-.092,1.718,1.718,0,0,0,.6-.3,1.607,1.607,0,0,0,.428-.495,1.527,1.527,0,0,0,.171-.69,2.321,2.321,0,0,0-.128-.726,1.274,1.274,0,0,0-.374-.531,1.9,1.9,0,0,0-.695-.342,3.853,3.853,0,0,0-1.05-.123h-1.123v3.3Z",
    transform: "translate(9.392 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M164.738,157.281H160.21v-7.445h.452v6.981h4.076Z",
    transform: "translate(10.278 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M172.29,157.281h-4.6v-7.445h4.3v.463h-3.832v2.771h3.162v.464h-3.162v3.283h4.137Z",
    transform: "translate(10.758 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M174.707,149.836h.512l2.8,6.762,2.746-6.762h.527L178,157.831Z",
    transform: "translate(11.209 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M188.552,157.281h-4.6v-7.445h4.3v.463h-3.833v2.771h3.162v.464h-3.162v3.283h4.139Z",
    transform: "translate(11.802 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M196.025,157.281H191.5v-7.445h.451v6.981h4.077Z",
    transform: "translate(12.286 9.613)",
    fill: "#030404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M198.826,156.528a.474.474,0,0,1,.128-.341.443.443,0,0,1,.337-.135.46.46,0,0,1,.475.476.438.438,0,0,1-.134.335.469.469,0,0,1-.341.129.44.44,0,0,1-.465-.464",
    transform: "translate(12.756 10.012)",
    fill: "#030404"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLionSpeakLogo);
export default __webpack_public_path__ + "static/media/lionSpeakLogo.5d645bbb.svg";
export { ForwardRef as ReactComponent };